import { multiplyWithFactor } from "@pentacode/openapi";
export const second = 1000;
export const minute = multiplyWithFactor(second, 60);
export const hour = multiplyWithFactor(minute, 60);
export const day = multiplyWithFactor(hour, 24);
export const week = multiplyWithFactor(day, 7);
//# sourceMappingURL=consts.js.map